import React, { useCallback } from 'react';

import { UIWizardFlowHeader, UIWizardFlowProgressBar } from '@futrli/ui-components';

import { useOnboardingContext } from '../../../onboarding.context';
import { useReportBuilderContext } from '../../../report-builder.context';
import styles from './onboarding-report-header.scss';

export interface OnboardingReportHeaderProps {
  scrollPosition?: number;
}

export const OnboardingReportHeader = ({ scrollPosition }: OnboardingReportHeaderProps) => {
  const { handleNext, isNextEnabled, progress, stepText } = useOnboardingContext();
  const { isAutoSaving, pageSetup } = useReportBuilderContext();

  const handleNextClick = useCallback(() => {
    handleNext();
  }, [handleNext]);

  return (
    <>
      <UIWizardFlowProgressBar value={progress} />
      <UIWizardFlowHeader
        description={stepText?.desc || ''}
        disableNext={!isNextEnabled || isAutoSaving}
        innerContainerClassname={styles[pageSetup.orientation]}
        onNext={handleNextClick}
        saving={isAutoSaving}
        shadow={!!scrollPosition}
        title={stepText?.title || ''}
      />
    </>
  );
};
